export enum markerState {
    add,
    selectPost,
    default,
}
